var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["../elements/combobox.html"] = require( "../elements/combobox.html" );
dependencies["./table.html"] = require( "./table.html" );
dependencies["./form.html"] = require( "./form.html" );




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/content/partialdelivery.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("../elements/combobox.html", false, "views/content/partialdelivery.html", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("combo", t_1);
output += " \r\n";
env.getTemplate("./table.html", false, "views/content/partialdelivery.html", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("table", t_4);
output += " \r\n";
env.getTemplate("./form.html", false, "views/content/partialdelivery.html", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
context.setVariable("form", t_7);
output += "\r\n<div class=\"content\">\r\n\t<form class=\"form-view grid\">\r\n\t\t<input type=\"hidden\" name=\"RentalType\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"formType"), env.opts.autoescape);
output += "\"> \r\n\t</form>\r\n\r\n\t<div class=\"table-view unsortable\">\r\n\t\t<form class=\"table-container\">\r\n\t\t\t";
output += "\r\n\t\t\t<div class=\"table-index sticky-div\">\r\n\t\t\t\t<div class=\"table-row\">\r\n\t\t\t\t\t";
output += "\r\n\t\t\t\t\t";
output += "\r\n\t\t\t\t\t\r\n\t\t\t\t\t";
frame = frame.push();
var t_12 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"Columns");
if(t_12) {var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("col", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
output += "\r\n\t\t\t\t\t<div \r\n\t\t\t\t\t\tclass=\"table-cell\" \r\n\t\t\t\t\t\tdata-column=\"";
output += runtime.suppressValue(runtime.memberLookup((t_13),"Name"), env.opts.autoescape);
output += "\" \r\n\t\t\t\t\t\ttitle=\"";
output += runtime.suppressValue(runtime.memberLookup((t_13),"Title"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t<div class=\"ellipsis\">\r\n\t\t\t\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((t_13),"Title"), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>";
;
}
}
frame = frame.pop();
output += "\r\n\r\n\t\t\t\t\t<div class=\"table-cell dropdown-info\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"UncollapseAll"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t<div class=\"ellipsis\" data-show-all-lower-fields>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"UncollapseAll"), env.opts.autoescape);
output += "</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\r\n\t\t\t";
output += "\r\n\t\t\t<div class=\"table-body bulkedit\">\r\n\t\t\t\t<div class=\"table-rows\">\r\n\t\t\t\t\t<div class=\"table-row-group\">\r\n\t\t\t\t\t\t<div class=\"table-row new-row\">\r\n\t\t\t\t\t\t\t";
output += "\r\n\t\t\t\t\t\t\t";
frame = frame.push();
var t_16 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"Columns");
if(t_16) {var t_15 = t_16.length;
for(var t_14=0; t_14 < t_16.length; t_14++) {
var t_17 = t_16[t_14];
frame.set("col", t_17);
frame.set("loop.index", t_14 + 1);
frame.set("loop.index0", t_14);
frame.set("loop.revindex", t_15 - t_14);
frame.set("loop.revindex0", t_15 - t_14 - 1);
frame.set("loop.first", t_14 === 0);
frame.set("loop.last", t_14 === t_15 - 1);
frame.set("loop.length", t_15);
output += runtime.suppressValue((lineno = 44, colno = 28, runtime.callWrap(runtime.memberLookup((t_4),"setColumnCell"), "table[\"setColumnCell\"]", context, [t_17,"",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"),"",runtime.contextOrFrameLookup(context, frame, "window")])), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t\t\t<div class=\"table-cell dropdown-info material-icons\" data-toggle-lower-field>&#xe313;</div>\r\n\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t<td class=\"lower-field hide\" colspan=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"Columns")),"length") + 2, env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t\t<form class=\"form-view grid\">\r\n\t\t\t\t\t\t\t\t\t<div class=\"row no-gutters\">\r\n\t\t\t\t\t\t\t\t\t\t";
frame = frame.push();
var t_20 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"ColumnsExtra");
if(t_20) {var t_19 = t_20.length;
for(var t_18=0; t_18 < t_20.length; t_18++) {
var t_21 = t_20[t_18];
frame.set("col", t_21);
frame.set("loop.index", t_18 + 1);
frame.set("loop.index0", t_18);
frame.set("loop.revindex", t_19 - t_18);
frame.set("loop.revindex0", t_19 - t_18 - 1);
frame.set("loop.first", t_18 === 0);
frame.set("loop.last", t_18 === t_19 - 1);
frame.set("loop.length", t_19);
output += "<div class=\"col col-xs-12 col-sm-12 col-md-6\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<label class=\"form-field\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"form-label\">";
output += runtime.suppressValue(runtime.memberLookup((t_21),"Title"), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t";
if(runtime.memberLookup((t_21),"IsRequired")) {
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"required-indicator\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"translations")),"RequiredField"), env.opts.autoescape);
output += "\">*</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t";
;
}
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"form-input required-field ";
output += runtime.suppressValue((runtime.memberLookup((t_21),"Type") == "Money"?"money":""), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t";
output += runtime.suppressValue((lineno = 62, colno = 36, runtime.callWrap(runtime.memberLookup((t_7),"createInputField"), "form[\"createInputField\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),t_21,runtime.memberLookup((t_21),"Type"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.memberLookup((t_21),"Initial"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "window")])), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t";
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</form>\r\n\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</form>\r\n\r\n\t\t";
output += "\r\n\t\t<div class=\"table-footer clearfix sticky-div stick-to-bottom\">\r\n\t\t\t<div class=\"fake-button button button-menu no-hover no-action\">\r\n\t\t\t\t<span data-select-count title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"SelectCount"), env.opts.autoescape);
output += "\">0</span>\r\n\t\t\t</div>\r\n\r\n\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"product") == "RentMagic") {
output += "\r\n\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t<div class=\"fake-button button button-menu no-hover no-action\">\r\n\t\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"TotalPriceExcVAT"), env.opts.autoescape);
output += ": <span data-total-price>0.00</span>\r\n\t\t\t\t</div>\r\n\r\n\t\t\t\t<div class=\"fake-button button button-menu no-hover no-action\">\r\n\t\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"TotalVAT"), env.opts.autoescape);
output += ": <span data-total-btw>0.00</span>\r\n\t\t\t\t</div>\r\n\r\n\t\t\t\t<div class=\"fake-button button button-menu no-hover no-action\">\r\n\t\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"TotalPriceIncVAT"), env.opts.autoescape);
output += ": <span data-total-btw-price>0.00</span>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t";
;
}
output += "\r\n\t\t</div>\r\n\t</div>\r\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/content/partialdelivery.html"] , dependencies)